import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-47">
      {/* Background with gradient and texture */}
      <div className="absolute inset-0 bg-gradient-to-b from-night-900 via-night-800 to-earth-900 z-0" data-id="element-48"></div>
      <div className="absolute inset-0 bg-grain opacity-20 z-0 mix-blend-overlay" data-id="element-49"></div>

      {/* Decorative stars */}
      <div className="absolute top-1/4 left-1/4 text-gold-400 opacity-20 animate-pulse" data-id="element-50">
        <Star size={16} fill="currentColor" data-id="element-51" />
      </div>
      <div className="absolute top-1/3 right-1/5 text-gold-400 opacity-30 animate-pulse" style={{
      animationDelay: '1s'
    }} data-id="element-52">
        <Star size={12} fill="currentColor" data-id="element-53" />
      </div>
      <div className="absolute bottom-1/3 left-1/3 text-gold-400 opacity-10 animate-pulse" style={{
      animationDelay: '2s'
    }} data-id="element-54">
        <Star size={20} fill="currentColor" data-id="element-55" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 text-center" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: 'easeOut'
      }} data-id="element-57">
          <div className="flex justify-center mb-6" data-id="element-58">
            <motion.div initial={{
            scale: 0,
            rotate: -180
          }} animate={{
            scale: 1,
            rotate: 0
          }} transition={{
            duration: 1.5,
            type: 'spring'
          }} className="text-gold-400" data-id="element-59">
              <Star size={48} fill="currentColor" className="drop-shadow-[0_0_15px_rgba(244,196,48,0.6)]" data-id="element-60" />
            </motion.div>
          </div>

          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl leading-tight text-cream-50 mb-10 text-glow" data-id="element-61">
            Guiding you through nature and grounding so you can make confident
            choices and step into new adventures.
          </h1>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6" data-id="element-62">
            <Button variant="primary" href="#contact" data-id="element-63">
              Book a Session
            </Button>
            <Button variant="outline" href="#offerings" data-id="element-64">
              Discover Group Journeys
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Bottom fade to blend with next section */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-earth-900 to-transparent z-10 pointer-events-none" data-id="element-65"></div>
    </section>;
}